// eslint-disable-next-line no-restricted-imports
import {pickBy} from 'ramda'

import {RawParamsType} from '../../utils/url/types/UrlParams'
import {FORCE_PREFIX} from '../config'

export const isForceToggleParam = (value: string, key: string) =>
  key.startsWith(FORCE_PREFIX)

export const filterABTestParameters = (params: RawParamsType): RawParamsType =>
  pickBy(isForceToggleParam, params)

export const removeForcePrefix = (params: RawParamsType) => {
  return Object.keys(params).reduce((previous, current) => {
    const newKey = current.split(FORCE_PREFIX)[1]
    return {
      ...previous,
      [newKey]: params[current]
    }
  }, {})
}

/**
 * Get the experiments keys that start with the prefix from the optimizely datafile source;
 * @param prefix - the prefix of the experiments keys to get;
 * @param dataFileExperiments - the optimizely datafile source;
 * @returns existing experiments keys that start with the prefix;
 */
export const getExperimentsByPrefix = (
  prefix: string,
  dataFileExperiments: string[] = []
): string[] => {
  return dataFileExperiments.filter(key => key.startsWith(prefix))
}

/**
 * Get the experiments keys that include the substring from the optimizely datafile source;
 * @param substring - the substring of the experiments keys to get;
 * @param dataFileExperiments - the optimizely datafile source;
 * @returns existing experiments keys that include the substring;
 */
export const getExperimentsBySubstring = (
  substring: string,
  dataFileExperiments: string[] = []
): string[] => {
  const lowerCaseSubstring = substring.toLowerCase()
  return dataFileExperiments.filter(key =>
    key.toLowerCase().includes(lowerCaseSubstring)
  )
}
